import { qfolderobj } from "./qfolderobj";

export function AddFolderToList(folderName, groupStatus, folderList) {
  var folderobj = new qfolderobj();
  folderobj.name = folderName;
  folderobj.groupstatus = groupStatus;
  folderList.push(folderobj);
}
